import { useCallback, useEffect, useRef, useState } from 'react';

export function useTableScrollY() {
  const tableWrapperElRef = useRef<HTMLDivElement | null>(null);
  const [tableScrollY, setTableScrollY] = useState<number | undefined>(undefined);

  const calcTableScrollY = useCallback(() => {
    const el = tableWrapperElRef.current;
    if (!el) return;
    const thead = el.querySelector('.ant-table-thead');
    const theadHeight = thead?.getBoundingClientRect().height ?? 40;
    const rect = el.getBoundingClientRect();
    const available = window.innerHeight - rect.top - theadHeight - 80;
    setTableScrollY(Math.max(available, 200));
  }, []);

  const tableWrapperRef = useCallback(
    (el: HTMLDivElement | null) => {
      tableWrapperElRef.current = el;
      if (!el) {
        setTableScrollY(undefined);
        return;
      }
      requestAnimationFrame(calcTableScrollY);
    },
    [calcTableScrollY]
  );

  useEffect(() => {
    window.addEventListener('resize', calcTableScrollY);
    return () => window.removeEventListener('resize', calcTableScrollY);
  }, [calcTableScrollY]);

  return { tableWrapperRef, tableScrollY };
}
